import styled from 'styled-components';

export const Container = styled.div``;

export const HiddenLinks = styled.div`
  display: none;
`;

export const Counter = styled.span`
  margin-left: 10px;
  margin-right: 10px;
  font-feature-settings: 'tnum' on;
`;
